import * as React from 'react'
import { ReactElement } from 'react'
import FileMessageForm from './FileMessageForm'
import FileMessageHeader from './FileMessageHeader'
import { makeStyles, mergeClasses } from '@fluentui/react-components'

const useStyles = makeStyles({
    container: {
        display: 'grid',
    },
})

export default function FileMessage(): ReactElement {
    const styles = useStyles()

    return (
        <div className={mergeClasses(styles.container)}>
            <FileMessageHeader />
            <FileMessageForm />
        </div>
    )
}
